import IAnalyticsAction from "../IAnalyticsAction";
import {Action} from "redux";
import {getType} from "typesafe-actions";
import {createShortcut} from "../../../player/actions";

export default function createShortcutHandler(action: Action): IAnalyticsAction | undefined {
    let name;

    switch (action.type) {
        case getType(createShortcut.request):
            name = "request";
            break;

        case getType(createShortcut.success):
            name = "create";
            break;

        case getType(createShortcut.failure):
            name = "skip";
            break;

        default: return;
    }

    return {
        category: "application",
        object: "shortcut",
        name: name,
    };
}